import { defineMessages } from 'react-intl'

export default defineMessages({
  deliverFiles: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.deliverFiles',
    defaultMessage: 'Deliver files',
  },
  deliverFilesConfirm: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.deliverFilesConfirm',
    defaultMessage: 'If automatic file delivery is setup for the customer, the files will be delivered regardless of other rules that may apply. Are you sure you want to continue?',
  },
  deliverFilesSuccess: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.deliverFilesSuccess',
    defaultMessage: 'Eligible task files delivered',
  },
  deliverFilesError: {
    id: 'containers.OrderPage.components.TaskPage.components.ActionsMenuFragments.deliverFilesError',
    defaultMessage: 'Failed to deliver task files!\n{errors}',
  },
})
